<!-- <template>
    <footer class="footer-info">
      <p>地址：xxx</p>
      <p>电话：xxx</p>
      <p>营业时间：xxx</p>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'FooterInfo',
  };
  </script>
  
  <style scoped>
  .footer-info {
    background-color: #333;
    color: white;
    text-align: center;
    padding: 1rem 0;
    width: 100%;
  }
    /*移动端*/
  @media(max-width: 768px){
      .footer-info{
          font-size: 0.9rem;
      }
  }
  </style> -->
  <template>
    <footer class="footer-info">
      <div class="footer-content">
        <div class="footer-logo">
          <img src="../assets/rc_logo1.png" alt="Restaurant Logo" class="logo-image">  <!-- 替换成你的 logo 图片 -->
        </div>
  
        <div class="footer-details">
          <div class="footer-address">
            <p>地址</p>
            <p>ADRESSE</p>
            <!-- <div class="address-images">
              <img src="../assets/ditu1.jpg" alt="Address Image 1" class="address-image">
              <img src="../assets/ditu.png" alt="Address Image 2" class="address-image">
            </div> -->
              <p>Gasthaus zur Linde</p>
              <p>Am Wümbach 24,98693 Ilmenau</p>
              <div class="address-images">
              <img src="../assets/ditu1.jpg" alt="Address Image 1" class="address-image">
              <img src="../assets/ditu.png" alt="Address Image 2" class="address-image">
            </div>
          </div>
  
          <div class="footer-opening-hours">
              <p>开业时间</p>
            <p>ÖFFNUNGSZEITEN</p>
            <p>Di. - So.: 11:30 - 15:00 Uhr</p>
            <p>17:30 - 22:00 Uhr</p>
          </div>
  
          <div class="footer-contact">
               <p>联系电话</p>
            <p>Kontakt</p>
            <p>Tel/WhatsApp: 017664353995</p>
          </div>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'FooterInfo',
  };
  </script>
  
  <style scoped>
  .footer-info {
    background-color: #c5a37c; /* 使用深红色，根据你的设计调整 */
    color: white;
    text-align: center; /* 整体居中 */
    padding: 2rem 0; /* 增加 padding */
    width: 100%;
    display: flex;          /* 使用 flexbox 布局 */
    justify-content: center; /* 水平居中 */
  }
  
  .footer-content {
      display: flex;
      flex-direction: column; /* 垂直排列 */
      align-items: center;     /* 水平居中 */
      max-width: 800px;       /* 设置最大宽度 */
      width: 100%;           /* 宽度占满 */
  }
  
  .footer-logo {
    margin-bottom: 1.5rem; /* logo 与下方内容的间距 */
  }
  
  .logo-image {
    max-width: 100px; /* 控制 logo 大小 */
    height: auto;
      display: block;
  }
  .footer-details {
      display: flex;
      justify-content: space-between; /* 使三个部分均匀分布 */
      width: 100%;                  /* 让 details 部分占满宽度 */
      text-align: left;            /* 文字左对齐 */
      padding: 0 1rem;           /* 左右 padding */
  }
  .footer-address,
  .footer-opening-hours,
  .footer-contact{
      flex: 1; /*平均分配*/
      margin: 0 0.5rem
  }
  
  .address-images {
    display: flex;          /* 使用 flexbox 让两个图标水平排列 */
    justify-content: flex-start; /* 左对齐 */
    margin-bottom: 0.5rem;     /* 与下方地址文字的间距 */
  }
  
  .address-image {
  /* width: 20px;  移除固定宽度 */
  /* height: 20px; 移除固定高度*/
  max-width: 45%;  /*  控制图片最大宽度 (相对于 .address-images) */
  height: auto;  /*  高度自动调整 */
  display: block; /* 消除图片底部间隙 */
}
  
  
  /*移动端*/
  @media (max-width: 768px) {
    .footer-info {
      font-size: 0.9rem;
        padding: 1rem 0; /* 调整 padding */
    }
      .footer-details{
          flex-direction: column; /* 移动端改为垂直排列 */
          align-items: center; /* 移动端居中 */
      }
  
    .footer-address,
    .footer-opening-hours,
    .footer-contact {
        margin-bottom: 1rem; /* 各部分之间的间距 */
        text-align: center;   /* 移动端文字居中 */
        width: 100%;
    }
  
    .address-images {
    justify-content: center; /*  移动端图片居中 */
    flex-wrap: wrap;     /*  允许图片换行 */
    gap: 0.5rem;         /*  移动端减小间距 */
  }
      .address-image{
     max-width: 100%; /* 移动端图片可以更大 */
  }
      .footer-logo{
          margin-bottom: 1rem; /*调整logo的间隔*/
      }
  }
  </style>